import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { Icon } from 'components/ui';
import { useSidebar } from 'contexts/SidebarContext';

const navigation = [
  { name: 'Content Library', href: '/dashboard/content-library', icon: 'library' },
  { name: 'Brand Assets', href: '/onboarding?step=7', icon: 'asset' },
  { name: 'Training', href: '/training', icon: 'calender' },
  { name: 'Onboarding Summary', href: '/onboarding?step=8', icon: 'list' },
  { name: 'Settings', href: '/dashboard/settings', icon: 'setting' },
];

interface NavigationProps {
  isCollapsed?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({ isCollapsed = false }) => {
  const { isMobile, setMobileOpen } = useSidebar();

  if (isCollapsed) {
    return <nav className="flex-1 p-4"></nav>;
  }

  return (
    <nav className="px-6 pb-1">
      {navigation.map((item) => (
        <NavLink
          key={item.name}
          to={item.href}
          onClick={() => isMobile && setMobileOpen(false)}
          className={({ isActive }) =>
            cn(
              'flex gap-2 px-2 items-center text-sm py-1 mb-1 rounded-lg transition-all',
              isActive ? 'bg-primary text-white' : 'text-black hover:bg-primary/10',
            )
          }
        >
          {/* @ts-ignore */}
          <Icon type={item?.icon} className="w-4" />
          <span className="font-medium">{item.name}</span>
        </NavLink>
      ))}
    </nav>
  );
};
